<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div class="main">
  <app-user-header header="Sign in"></app-user-header>

  <div fxLayout="row wrap" fxLayoutAlign="center center">
    <form [formGroup]="signInForm">
      <div>
        <input
          id="phoneoremail"
          formControlName="userDetails"
          type="text"
          placeholder="Enter phone number or email"
          i18n-placeholder
          class="notranslate nvc-input nvc-input-width"
        />
        <div *ngIf="userDetails.invalid && userDetails.dirty">
          <small
            id="userdetailsreq"
            class="error notranslate"
            i18n="@@User_details_are_required"
            *ngIf="userDetails.errors?.required"
            >Userdetails is required</small
          >
          <small
            id="userdetailsinvalid"
            class="error notranslate"
            i18n="@@User_details_are_invalid"
            *ngIf="userDetails.errors?.pattern"
            >Userdetails is invalid</small
          >
        </div>
      </div>

      <div class="nvc-input-div">
        <div
          class="nvc-input nvc-input-width"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <input
            id="password"
            fxFlex="90"
            [type]="passwordType"
            formControlName="userPassword"
            placeholder="Enter Password"
            i18n-placeholder
            class="notranslate nvc-input nvc-input-tag"
          />
          <mat-icon
            [svgIcon]="passwordVisibility ? 'eyeIcon' : 'eyeSlashIcon'"
            class="nvc-eye ws-cursor-pointer"
            (click)="togglePasswordVisibility()"
          >
          </mat-icon>
        </div>
      </div>
      <div *ngIf="userPassword.invalid && userPassword.dirty">
        <small
          id="passwordreq"
          class="error notranslate"
          i18n="@@User_Password_is_required"
          *ngIf="userPassword.errors?.required"
          >Userpassword is required</small
        >
        <small
          id="pwdlength"
          class="error notranslate"
          i18n="@@User_Password_must_be"
          *ngIf="userPassword.errors?.minlength"
          >Userpassword must be at least 8 characters</small
        >
      </div>

      <button
        id="login"
        [disabled]="!validCredentials()"
        [ngClass]="{ 'nvc-disabled': !validCredentials() }"
        class="submit-button notranslate"
        type="submit"
        (click)="yourRatingFunction()"
        i18n
      >
        LOGIN
      </button>
    </form>
  </div>
  <div
    *ngIf="!isValidUser"
    fxLayout="row"
    fxLayoutAlign="center center"
    class="link"
  >
    <p id="errormessage" class="error">{{ errorMessage }}</p>
  </div>
  <div *ngIf="userError" fxLayout="row" fxLayoutAlign="center center">
    <p id="usererror" class="error">{{ userError }}</p>
  </div>
  <div
    (click)="forgotPasswordFunction()"
    class="ispacing"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <p id="forgotpassword" class="link bspacing">
      <u class="notranslate" i18n>Forgot Your Password?</u>
    </p>
  </div>

  <!-- <div fxLayout="row" fxLayoutAlign="center center" class="bspacing">
    or
  </div> -->

  <!-- <div class='icon-position'fxLayout="row" fxLayoutAlign="center">
    <div fxLayout="row" fxLayoutAlign="end center" class="sspacing">
      <img  src="assets/images/linkedin.svg" alt="in">
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" class="sspacing">
     <a [href]="facebook" > <img src="assets/images/facebook.svg" alt="fb"></a>
    </div>
  </div> -->
  <!-- <br> -->
  <div class="bottom">
    <p id="donthaveaccount" (click)="dontHaveAnAccountFunction()">
      <u class="notranslate" i18n>Don't have an Customer Account?</u>
    </p>
  </div>
</div>
